import { ISnookerTable } from "../../types/ISnookerTable";
import { IStyleSettings } from "../../types/IStyleSettings";
import { ISnookerData } from "./ISnookerData";

let data: ISnookerTable[];
let selectedTable: ISnookerTable;
let tableStyle: IStyleSettings;

export class SnookerData implements ISnookerData {
  public setData(d: ISnookerTable[]): void {
    data = d;
    //tableStyle = JSON.parse();
  }
  getData(): ISnookerTable[] {
    return data;
  }
  public setSelected(data: ISnookerTable): void {
    selectedTable = data;
  }
  getSelected(): ISnookerTable {
    return selectedTable;
  }
}
